module.exports = __webpack_public_path__ + "static/media/luma-bg.c56d7eb5.webp";